export function target() {
  return this.module === 'NewFooter' && this.data.contacts;
}

export function migrate() {
  const { contacts } = this.data;

  const targetTypes = ['razao', 'endereco'];

  contacts.forEach((contact) => {
    if (
      targetTypes.includes(contact.contactType) &&
      contact.linkURL &&
      contact.linkURL.value &&
      contact.label &&
      typeof contact.enableLinkURL === 'undefined'
    ) {
      // eslint-disable-next-line no-param-reassign
      contact.enableLinkURL = true;
    }
  });
}
